/** Query param the bag reads to scroll to and highlight one line (`/cart?linha=<lineId>`). */
export const CART_LINE_PARAM = "linha"

/** Link to the bag with one line highlighted. */
export function cartLineHref(cartLineId: string): string {
  return `/cart?${CART_LINE_PARAM}=${encodeURIComponent(cartLineId)}`
}
